import React from "react";
import PageHero from "../components/PageHero";
import SectionHeader from "../components/SectionHeader";
import CategoryCard from "../components/CategoryCard";
import CTASection from "../components/CTASection";
import { PRODUCT_CATEGORIES } from "../lib/constants";

const BENEFITS = [
  "Reduce electricity cost",
  "Improve energy independence",
  "Reduce diesel generator dependency",
  "Better campus safety",
  "Better public infrastructure",
  "Long-term cost savings",
  "Sustainable development support",
];

const SECTIONS = [
  { t: "Rooftop Solar Solutions", d: "On-grid, hybrid, with battery backup. Sized for institutions and government buildings." },
  { t: "Solar Street Lights", d: "Integrated, semi-integrated, garden and pathway lights for streets, panchayats, campuses." },
  { t: "High Mast Lighting", d: "LED high mast lighting for grounds, public spaces, markets, yards, and institutions." },
  { t: "LED Lighting", d: "Street, flood, panel, indoor, outdoor, emergency and institutional lighting." },
  { t: "Solar with Battery Backup", d: "Hybrid systems for uninterrupted institutional energy use." },
  { t: "Electrical & Power Backup", d: "UPS, batteries, inverters, panels, wiring through qualified partners." },
  { t: "AMC & Technical Support", d: "Maintenance and execution support through qualified technical partners." },
];

export default function RenewableEnergy() {
  const featured = PRODUCT_CATEGORIES.filter((c) =>
    ["renewable-energy", "solar-street-lighting", "high-mast-led-lighting", "electrical-power-backup"].includes(c.slug)
  );
  return (
    <div>
      <PageHero
        kicker="Renewable Energy & Lighting"
        title="Renewable Energy, Solar Lighting & Public Infrastructure Solutions"
        description="Supporting government departments, institutions, residential schools, hostels, public bodies, and corporates with rooftop solar, solar street lights, high mast lighting, LED lighting, battery backup, electrical infrastructure, and related project fulfilment support."
        primary={{ to: "/submit", label: "Submit Solar / Lighting Requirement" }}
        secondary={{ to: "/downloads", label: "Download Brochure" }}
        image="/img/rooftop-solar.png"
      />

      <section className="section">
        <div className="container-x">
          <SectionHeader kicker="Solutions" title="Solar, Lighting & Electrical Capabilities" />
          <div className="grid-cards mt-8">
            {SECTIONS.map((s) => (
              <div key={s.t} className="card-premium p-5">
                <div className="font-semibold text-navy text-base">{s.t}</div>
                <div className="divider-gold" />
                <p className="text-sm text-[var(--melopa-muted)]">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-soft">
        <div className="container-x">
          <SectionHeader kicker="Benefits" title="Why renewable energy & solar lighting" />
          <ul className="list-tick mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6">
            {BENEFITS.map((b) => <li key={b}>{b}</li>)}
          </ul>
        </div>
      </section>

      <section className="section">
        <div className="container-x">
          <SectionHeader kicker="Featured Categories" title="Detailed offerings" />
          <div className="grid-cards mt-8">
            {featured.map((c) => (
              <CategoryCard key={c.slug} title={c.name} desc={c.desc} icon={c.icon} items={c.items} to="/submit" />
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title="Have a solar, lighting or electrical requirement?"
        description="Share quantity, site details, and timelines. Our team will revert with a suitable proposal."
      />
    </div>
  );
}
